<div class="min-h-screen w-full flex flex-col">
    <app-header></app-header>
    <app-toolbar></app-toolbar>
    <app-submenu [items]="subMenuItems" [isHide]="true"></app-submenu>
    <div class="flex flex-col lg:flex-row">
        <div
            class="lg:min-h-[100vh] lg:w-[70%] 2xl:w-[80%] w-full bg-[#f5f5f5] lg:border-r-[3px] lg:border-[#27368A] pb-[70px] relative">
            <div class="mb-5 pt-[19px] pb-[18px] px-4 border-b-[3px] border-[#BDBDBD] ">
                <h2 class="text-[16px] font-extrabold mb-0">Items</h2>
                <!-- <p class="text-[gray] text-md mt-0">Elija los items que desea cobrar</p> -->
            </div>
            <div class="w-[300px] absolute top-[72px] right-[7px] hidden lg:block p-2 bg-white shadow-lg rounded-md">
                <section class="border-[1px] border-gray-300 rounded-md p-2 mb-1 ">
                    <div>
                        <h3 class="text-[#27368A] text-md">Importe que recibes</h3>
                        <div>
                            <input (focus)="validateZeroInput($event)" (keyup)="changeToReturn($event)"
                                [(ngModel)]="putMoney" #putMoneyInput type="text" placeholder="Introduce el importe"
                                class="w-[100%] bg-[#f0f0f0] p-2 rounded-md outline-none">
                        </div>
                    </div>
                    <div class="flex justify-between">
                        <span class="text-[#27368A] text-sm">Cambio a devolver</span>
                        <span class="text-red-600 font-bold">{{ change + '€'}}</span>
                    </div>
                    <div class="mt-2">
                        <div class="flex gap-1 mb-1">
                            <button
                                class="transition-all bg-[#4554a8] rounded-md text-white text-center text-sm font-semibold py-2 basis-1/2"
                                [ngClass]="{ '!bg-[#27368a]': selectedPaymentType === 'EFECTIVO' }"
                                (click)="paymentType('EFECTIVO')">Efectivo</button>
                            <button
                                class="transition-all bg-[#4554a8] rounded-md text-white text-center text-sm font-semibold py-2 basis-1/2"
                                [ngClass]="{ '!bg-[#27368a]': selectedPaymentType === 'TARJETA' }"
                                (click)="paymentType('TARJETA')">Tarjeta</button>
                        </div>
                        <div class="flex gap-1">

                            <button
                                class="transition-all bg-[#4554a8] rounded-md text-white text-center text-sm font-semibold py-2 basis-1/2"
                                [ngClass]="{ '!bg-[#27368a]': selectedPaymentType === 'BIZUM' }"
                                (click)="paymentType('BIZUM')">Bizum</button>
                            <button
                                class="transition-all bg-[#4554a8] rounded-md text-white text-center text-sm font-semibold py-2 basis-1/2"
                                [ngClass]="{ '!bg-[#27368a]': selectedPaymentType === 'TRANSFERENCIA' }"
                                (click)="paymentType('TRANSFERENCIA')">Transferencia</button>
                        </div>
                        <div class="flex lg:flex-col gap-1 mt-1">
                            <button
                                class="bg-[#db071b] text-white text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-40 py-2 w-[100%] rounded-md"
                                (click)="resetCashierEntries()">Resetear transacciones</button>
                            <button
                                class="bg-[#42BC18] text-white text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-40 py-2 w-[100%] rounded-md "
                                (click)="confirmEntry()"
                                [disabled]="!selectedPaymentType || !allowConfirm">Confirmar</button>
                        </div>
                    </div>
                </section>
                <section class="flex gap-2 lg:flex-col border-[1px] border-gray-300 rounded-md p-2 mb-1">
                    <button
                        class="bg-[#42BC18] text-white text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-40 basis-1/2 py-2 rounded-md "
                        (click)="handleCashCashier(true)">Entrada de cambio</button>
                    <button
                        class="bg-[#db071b] text-white text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-40 basis-1/2 py-2 rounded-md"
                        (click)="handleCashCashier(false)">Salida de caja</button>
                </section>
            </div>
            <div
                class="flex flex-wrap justify-center items-stretch gap-4 w-full pt-5 px-3 lg:pr-[400px] xl:pr-[300px] 2xl:pr-[320px]">
                <ng-container *ngIf="toggleActividadesFlag">
                    <div class="w-full">
                        <div class="bg-white p-3 rounded-md shadow-lg max-w-[500px] xxl:max-w-[620px]  mx-auto">
                            <h3 class="text-md text-center mb-2">Actividades</h3>
                            <div class="table-container  overflow-x-auto mx-auto">
                                <table
                                    *ngIf="selectedBookings[indexBooking] && selectedBookings[indexBooking].services.length > 0"
                                    class="text-sm text-left rtl:text-right text-gray-500 w-[480px] xxl:w-[590px]">
                                    <thead class="">
                                        <tr>
                                            <th class="px-6 py-3">Actividad</th>
                                            <th class="px-6 py-3">Fecha y hora</th>
                                            <th class="px-6 py-3">Subtotal</th>
                                        </tr>
                                    </thead>
                                    <tbody class="bg-[#F4F4F4] divide-y-[3px] divide-[#E6E6E6]">
                                        <ng-container
                                            *ngIf="selectedBookings[indexBooking] && selectedBookings[indexBooking].services.length > 0; ">
                                            <tr *ngFor="let bookservice of selectedBookings[indexBooking].services; let i = index;"
                                                class="text-[#383838] text-[12px] font-[300]">
                                                <td class="px-6 py-4">
                                                    {{ getServiceName(bookservice.service_profile_id) }}<br>
                                                    <b>({{ bookservice.units}}x)</b> {{
                                                    bookservice.service_profile?.name}}
                                                </td>
                                                <td class="px-6 py-4">
                                                    {{bookservice.date}} {{bookservice.hour}}
                                                </td>
                                                <td class="px-6 py-4 text-base text-right font-bold text-red-700">
                                                    {{ bookservice.unit_price * bookservice.units | currency:'EUR' }}
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <button *ngFor="let item of billables; let i = index"
                    class="hover:cursor-pointer flex items-center gap-2 hover:bg-[rgb(250,250,250)] py-4 px-3 w-[200px] xl:w-[240px] rounded-md bg-white shadow-lg border border-gray-200 transition-all text-center text-gray-600"
                    (click)="handleBillable(i, item)">
                    <i class="pi pi-plus-circle"></i>
                    {{item[0].name}}
                </button>
                <div class="w-full flex justify-center gap-4">
                    <button type="button"
                        class="cursor-pointer font-bold transition-all billable-item bg-[#4554a8] hover:bg-[#27368a] border-0 rounded-md py-4 px-3 w-[220px] text-center text-white flex items-center gap-2"
                        (click)="handleOthers()">
                        <i class="pi pi-plus-circle"></i>
                        Otros
                    </button>
                    <button
                        class="cursor-pointer  billable-item rounded-md py-4 px-3 w-[220px] font-bold text-white text-center disabled:opacity-65 bg-[#4554a8] hover:bg-[#27368a] border-0 flex items-center gap-2"
                        (click)="handleBooking()" [disabled]="isPayBookingCash">
                        <i class="pi pi-plus-circle"></i>

                        Reserva
                    </button>
                </div>
                <div class="flex justify-center">
                    <div class="p-2 flex justify-center gap-4 border-[3px] border-gray-300 mt-4 rounded-md">
                        <button type="button"
                            class="cursor-pointer font-bold transition-all billable-item bg-[#4554a8] hover:bg-[#27368a] border-0 rounded-md py-4 px-3 w-[220px] text-center text-white flex items-center gap-2"
                            (click)="showSaveDraft = true">
                            <i class="pi pi-save"></i>
                            Guardar borrador
                        </button>
                        <button type="button"
                            class="cursor-pointer font-bold transition-all billable-item bg-[#4554a8] hover:bg-[#27368a] border-0 rounded-md py-4 px-3 w-[220px] text-center text-white flex items-center gap-2"
                            (click)="onShowListDraft($event)">
                            <i class="pi pi-refresh"></i>
                            Recuperar borrador
                        </button>
                    </div>
                </div>
            </div>

        </div>
        <div
            class="lg:h-[100vh] lg:w-[30%] 2xl:w-[20%] w-full bg-white shadow-[0_-21px_105px_-54px_rgba(0,0,0,0.3)] lg:shadow-[-21px_0_105px_-54px_rgba(0,0,0,0.3)]">
            <div class="flex justify-between  pt-[19px] pb-[18px] px-3 border-b-[3px] border-[#BDBDBD] ">
                <p class="text-[16px] font-extrabold mb-0">Ticket a imprimir</p>
                <span class="text-base font-bold">{{ totalSumTicket }}</span>
            </div>
            <div class="lg:h-[calc(100vh-327px)] lg:overflow-y-auto"
                [ngClass]="{'lg:!h-[calc(100vh-352px)]': (ticket !== undefined && ticket.details !== undefined && ticket.details.length > 0)}">

                <div class="py-3 px-3" *ngIf="ticket !== undefined">
                    <section *ngIf="ticket.details?.length === 0"
                        class="flex justify-center items-center w-full border border-dashed border-slate-500 rounded-md p-6 mb-4">
                        <h1 class="text-md text-center text-slate-500">
                            No hay cobros registrados<br>
                            <small>Introduzca un importe</small>
                        </h1>
                    </section>
                    <section *ngIf="ticket.details !== undefined && ticket.details.length > 0" class="w-full">
                        <div *ngFor="let detail of ticket.details; let i = index"
                            class="border-[1px] border-gray-300 rounded-md p-2 mb-1">
                            <div class="flex justify-between">
                                <div>
                                    <h3 class="text-sm truncate ...">{{ detail.concept }}</h3>
                                    <!-- <ng-container *ngIf="selectedBookings && detail.lock_units">
                                        <button type="button" style="width: 30px; height: 30px;"
                                            class="bg-[#42BC18] rounded-md p-1" pTooltip="Actividades"
                                            (click)="toggleActividades(detail.booking_id)" tooltipPosition="bottom">
                                            <img src="/assets/icons/icon_coin.png" style="width: 30px; height: 20px;">
                                        </button>
                                    </ng-container> -->
                                </div>
                                <div class="flex gap-1">

                                    <ng-container *ngIf="selectedBookings && detail.lock_units">
                                        <i class="pi pi-database cursor-pointer"
                                            (click)="toggleActividades(detail.booking_id)" style="color: #42BC18;"></i>
                                    </ng-container>
                                    <i class="pi pi-trash cursor-pointer" (click)="deleteConcept(i)"
                                        style="color: firebrick;"></i>
                                </div>
                            </div>
                            <div class="flex justify-between mt-4">
                                <div>
                                    <span class="font-bold text-sm text-red-700 whitespace-nowrap">{{ detail.unit_price
                                        *
                                        detail.units | currency:'EUR'}}</span>
                                </div>
                                <div class="">
                                    <p-inputNumber [(ngModel)]="ticket.details[i].units"
                                        (onInput)="changeUnits($event, i)" [showButtons]="true"
                                        styleClass="text-center input-item-numbers" buttonLayout="horizontal"
                                        [readonly]="detail.lock_units ?? false" spinnerMode="vertical"
                                        decrementButtonClass="p-button-secondary"
                                        incrementButtonClass="p-button-secondary" incrementButtonIcon="pi pi-plus"
                                        [min]="1" decrementButtonIcon="pi pi-minus" />
                                </div>
                            </div>
                        </div>
                    </section>

                </div>
                <div class="pt-3 pb-2 px-3">
                    <section class="border-[1px] border-gray-300 rounded-md p-2 mb-1 lg:hidden">
                        <div>
                            <h3 class="text-[#27368A] text-md">Importe que recibes</h3>
                            <div>
                                <input (focus)="validateZeroInput($event)" (keyup)="changeToReturn($event)"
                                    [(ngModel)]="putMoney" #putMoneyInput type="text" placeholder="Introduce el importe"
                                    class="w-[100%] bg-[#f0f0f0] p-2 rounded-md outline-none">
                            </div>
                        </div>
                        <div class="flex justify-between">
                            <span class="text-[#27368A] text-sm">Cambio a devolver</span>
                            <span class="text-red-600 font-bold">{{ change + '€'}}</span>
                        </div>
                        <div class="mt-2">
                            <div class="flex gap-1 mb-1">
                                <button
                                    class="transition-all bg-[#4554a8] rounded-md text-white text-center text-sm font-semibold py-2 basis-1/2"
                                    [ngClass]="{ '!bg-[#27368a]': selectedPaymentType === 'EFECTIVO' }"
                                    (click)="paymentType('EFECTIVO')">Efectivo</button>
                                <button
                                    class="transition-all bg-[#4554a8] rounded-md text-white text-center text-sm font-semibold py-2 basis-1/2"
                                    [ngClass]="{ '!bg-[#27368a]': selectedPaymentType === 'TARJETA' }"
                                    (click)="paymentType('TARJETA')">Tarjeta</button>
                            </div>
                            <div class="flex gap-1">

                                <button
                                    class="transition-all bg-[#4554a8] rounded-md text-white text-center text-sm font-semibold py-2 basis-1/2"
                                    [ngClass]="{ '!bg-[#27368a]': selectedPaymentType === 'BIZUM' }"
                                    (click)="paymentType('BIZUM')">Bizum</button>
                                <button
                                    class="transition-all bg-[#4554a8] rounded-md text-white text-center text-sm font-semibold py-2 basis-1/2"
                                    [ngClass]="{ '!bg-[#27368a]': selectedPaymentType === 'TRANSFERENCIA' }"
                                    (click)="paymentType('TRANSFERENCIA')">Transferencia</button>
                            </div>
                            <div class="flex lg:flex-col gap-1 mt-1">
                                <button
                                    class="bg-[#db071b] text-white text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-40 py-2 w-[100%] rounded-md"
                                    (click)="resetCashierEntries()">Resetear transacciones</button>
                                <button
                                    class="bg-[#42BC18] text-white text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-40 py-2 w-[100%] rounded-md "
                                    (click)="confirmEntry()"
                                    [disabled]="!selectedPaymentType || !allowConfirm">Confirmar</button>
                            </div>
                        </div>
                    </section>
                </div>
                <div class=" px-3 lg:hidden">
                    <section class="flex gap-2 lg:flex-col border-[1px] border-gray-300 rounded-md p-2 mb-1">
                        <button
                            class="bg-[#42BC18] text-white text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-40 basis-1/2 py-2 rounded-md "
                            (click)="handleCashCashier(true)">Entrada de cambio</button>
                        <button
                            class="bg-[#db071b] text-white text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-40 basis-1/2 py-2 rounded-md"
                            (click)="handleCashCashier(false)">Salida de caja</button>
                    </section>
                </div>
            </div>
            <div class="py-3 px-3 text-center">
                <div *ngIf="ticket !== undefined && ticket.details !== undefined">
                    <div *ngIf="ticket.details.length > 0" class="flex justify-between">
                        <p class="text-sm ">{{ (isCashOutflow)? 'Salida de caja' : 'Restante a cobrar' }}:</p>
                        <span class="text-base font-bold">{{ totalRestanteTickets }}</span>
                    </div>
                </div>
                <button
                    class="bg-[#4554a8] hover:bg-[#27368a] text-white text-lg font-bold w-[100%] rounded-md py-3 disabled:cursor-not-allowed disabled:opacity-40 max-w-[500px]"
                    (click)="printTicket()" [disabled]="!confirmedEntry">Finalizar</button>
            </div>
        </div>
    </div>
</div>

<p-dialog header="Selecciona la talla" [(visible)]="showSizes" [modal]="true" [style]="{width: '20vw'}"
    *ngIf="billables.length > 0">
    <p>{{this.billables[viewSelectedSizes][0].name}}</p>
    <div class="flex flex-col gap-3">
        <div *ngFor="let item of this.billables[viewSelectedSizes]; let i = index;">
            <div class="flex flex-row gap-2">
                <input (click)="confirmBillableSize(i)" type="radio" value="size" [(ngModel)]="size">
                <label [for]="item.size">{{ item.size }}</label>
            </div>
        </div>
    </div>
</p-dialog>
<p-dialog header="Añadir Otros" [(visible)]="showOther" [modal]="true" [style]="{width: '20vw'}">
    <div class="flex flex-col gap-3">
        <div class="flex flex-row gap-2 align-middle justify-between">
            <label for="concept">Concepto</label>
            <input type="text" [(ngModel)]="otherDetail.concept" class="bg-[#F3F3F3] flex justify-end py-1 px-2 w-52">
        </div>
        <div class="flex flex-row gap-2 align-middle justify-between">
            <label>Precio und.</label>
            <input type="number" [(ngModel)]="otherDetail.unitPrice" min="0"
                class="bg-[#F3F3F3] flex justify-end py-1 px-2 w-52">
        </div>
    </div>
    <div class="flex justify-end">
        <button
            class="bg-[#42BC18] justify-center items-center text-white text-lg font-bold mt-6 p-2 w-20 disabled:cursor-not-allowed disabled:opacity-40"
            (click)="confirmOthers()" [disabled]="otherDetail.unitPrice === 0 || !otherDetail.concept">Añadir</button>
    </div>
</p-dialog>
<p-dialog header="Cobrar importe de reserva" [(visible)]="showBooking" [modal]="true"
    [style]="{width: '90%', maxWidth: '400px', minHeight: '400px'}">
    <div class="flex flex-col gap-3">
        <div class="flex flex-row gap-2 align-middle justify-between">
            <label for="concept" class="w-[160px]">Buscar reserva</label>
            <!-- <input type="text" [(ngModel)]="inputSearchBooking" (blur)="searchBooking($event)"
        class="bg-[#F3F3F3] flex justify-end py-1 px-2 w-full"> -->
            <p-autoComplete #searcherAutocomplete [suggestions]="results_bookings" [showClear]="true"
                class="block w-full" [virtualScrollItemSize]="40" (completeMethod)="searchBooking($event)"
                (onSelect)="onSelectBooking($event)" styleClass="block w-full" field="reference"
                [(ngModel)]="selectedBooking"
                inputStyleClass="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 w-full px-2 mb-2 "
                placeholder="Buscar reserva" [delay]="500">
                <ng-template let-item pTemplate="itemTemplate">
                    <div class="autocomplete-item">
                        <h3>{{item.reference}}</h3>
                        <span class="block text-xs text-gray-700">Cliente: {{item.customer?.name}}</span>
                        <span class="block text-xs text-gray-700">CIF: {{item.customer?.cif}}</span>
                        <span class="block text-xs text-gray-700">Total: {{item.total_amount}}</span>
                        <span class="block text-xs text-gray-700">Faltante: {{(item.total_amount -
                            item.total_paid)}}</span>
                    </div>
                </ng-template>
            </p-autoComplete>
        </div>
        <ng-container *ngIf="selectedBooking && selectedBooking.reference">
            <div class=" gap-2 align-middle justify-between">
                <label for="total_amount" class="w-full block">Monto total</label>
                <input id="total_amount" type="text" [(ngModel)]="totalAmountBooking" pattern="[0-9]*" readonly
                    class="bg-[#F3F3F3] block  py-1 px-2 w-full">
            </div>
            <div class=" gap-2 align-middle justify-between">
                <label for="total_amount" class="w-full block">Monto restante a pagar</label>
                <input id="total_amount" type="text" [(ngModel)]="totalToPayAmountBooking" pattern="[0-9]*" readonly
                    class="bg-[#F3F3F3] block py-1 px-2 w-full">
            </div>
            <div class=" gap-2 align-middle justify-between mb-[20px]">
                <label for="total_amount" class="w-full block">Importe</label>
                <input
                    (focus)="(cashAmountBooking == 0)? cashAmountBooking = '' : cashAmountBooking = cashAmountBooking;"
                    id="total_amount" type="text" [(ngModel)]="cashAmountBooking"
                    (keydown)="utils.onlyNumbersFloatWhitNegative($event)" class="bg-[#F3F3F3] block  py-1 px-2 w-full">
            </div>
        </ng-container>
        <ng-container *ngIf="validateBookingStatusChange()">
          <div>
            <label for="" class="text-[#27368A] font-bold text-base">Cambiar estado de reserva</label>
            <div class="flex gap-2">
              <input type="radio" [(ngModel)]="bookingStatus" value="4">
              <span>Pagado</span>
            </div>
            <div class="flex gap-2">
              <input type="radio" [(ngModel)]="bookingStatus" value="6">
              <span>Cancelar reserva</span>
            </div>
            <div class="flex gap-2">
              <input type="radio" [(ngModel)]="bookingStatus" value="2">
              <span>Pendiente de pago</span>
            </div>
            <div class="flex gap-2">
              <input type="radio" [(ngModel)]="bookingStatus" value="3">
              <span>Reservado</span>
            </div>
          </div>
        </ng-container>
    </div>
    <div class="flex justify-end" *ngIf="selectedBooking && selectedBooking.reference">
        <button
            class="bg-[#42BC18] justify-center items-center text-white text-lg font-bold mt-6 p-2 w-20 disabled:cursor-not-allowed disabled:opacity-40"
            (click)="confirmBookingCash()" [disabled]="validateAddImportBooking()">
            Añadir
        </button>
    </div>
</p-dialog>
<p-dialog header="Guardar borrador" [(visible)]="showSaveDraft" [modal]="true"
    [style]="{width: '90%', maxWidth: '500px'}">
    <div class="flex flex-col gap-3">
        <div class="flex flex-row gap-2 align-middle justify-between">
            <label for="total_amount" class="w-[160px]">Alias</label>
            <input type="text" [(ngModel)]="nameAlias" class="bg-[#F3F3F3] flex justify-end py-1 px-2 w-full">
        </div>

    </div>
    <div class="flex justify-end">
        <button
            class="bg-[#42BC18] justify-center items-center text-white text-lg font-bold mt-6 p-2 w-20 disabled:cursor-not-allowed disabled:opacity-40"
            (click)="saveDraft($event)" [disabled]="nameAlias.trim() == ''">Guardar</button>
    </div>
</p-dialog>
<p-dialog header="Lista de borradores de tickets" [(visible)]="showListDraft" [modal]="true"
    [style]="{width: '90%', maxWidth: '500px'}">
    <div class="flex flex-col gap-3">
        <div class="flex flex-row gap-2 align-middle justify-between">
            <div class="card flex justify-content-center w-full p-listbox-container">
                <p-listbox [options]="ticketsDraft" [(ngModel)]="selectedTicketDraft" optionLabel="alias"
                    [style]="{'width': '100%'}" [id]="'list-tickets-draft'" (onClick)="onSelectTicketDraft($event)"
                    [filter]="true" [listStyle]="{'max-height': '220px'}"></p-listbox>
            </div>
        </div>

    </div>
    <div class="flex justify-end">
        <!-- <button
      class="bg-[#42BC18] justify-center items-center text-white text-lg font-bold mt-6 p-2 w-20 disabled:cursor-not-allowed disabled:opacity-40"
      [disabled]="nameAlias.trim() == ''">Guardar</button> -->
    </div>
</p-dialog>
<p-confirmDialog #cd [style]="{ width: '95%', maxWidth: '400px' }">
    <ng-template pTemplate="header">
        <h3 class="border-b border-gray-300 w-full pb-2 text-lg">{{ isCashIn ? 'Va a insertar cambio a caja' : 'Va a
            pagar por caja' }}</h3>
    </ng-template>
    <ng-template pTemplate="icon">
    </ng-template>
    <ng-template pTemplate="message">
        <ng-container *ngIf="isCashIn">
            <section class="flex justify-center w-full">
                <div>
                    <p class="block ">Indique la cantidad</p>
                    <input class="flex align-middle w-full bg-[#f0f0f0] px-3 py-2 rounded-[10px] h-10"
                        appOnlyNumbersFloat appValidateZeroInput (focus)="validateZeroInput($event)" type="text"
                        placeholder="Importe..." [(ngModel)]="cashAmount">
                </div>
            </section>
        </ng-container>
        <ng-container *ngIf="!isCashIn">
            <section class="flex justify-center w-full">
                <div>
                    <p class="block ">Indique la cantidad</p>
                    <input class="flex align-middle w-full bg-[#f0f0f0] px-3 py-2 rounded-[10px] h-10"
                        appOnlyNumbersNegativeFloat appValidateZeroInput (focus)="validateZeroInput($event)" type="text"
                        placeholder="Importe..." [(ngModel)]="cashAmount">
                </div>
            </section>
        </ng-container>

    </ng-template>
    <ng-template pTemplate="footer">
        <button class="bg-red-600 justify-center items-center text-white text-normal rounded-xl py-1 px-4 mr-1"
            type="button" pButton label="No" (click)="cd.reject()"></button>
        <button class="bg-green-600 justify-center items-center text-white text-normal rounded-xl py-1 px-4"
            type="button" pButton label="Si" (click)="cd.accept()"></button>
    </ng-template>
</p-confirmDialog>
<p-toast></p-toast>
